/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/399-hangouts': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M7.997 0a6.91 6.91 0 00-6.909 6.909c0 3.616 3.294 6.547 6.909 6.547V16c4.197-2.128 6.916-5.556 6.916-9.091 0-3.816-3.1-6.909-6.916-6.909zM7 8c0 .828-.447 1.5-1 1.5V8H4V5h3v3zm5 0c0 .828-.447 1.5-1 1.5V8H9V5h3v3z"/>'
  }
})
